import { useDispatch } from 'react-redux'
import { useMutation } from '@cbgms/base/http/use-query'
import { requestNewAccessToken } from 'app-support/auth/state/actions'
import { getCookie } from '@cbgms/base/utils/helpers'

interface TokenRefreshParams {
  emailAddress: string
  refreshToken: string
}

export function useTokenRefresh() {
  const dispatch = useDispatch()

  return useMutation(['token-refresh'], async ({ emailAddress, refreshToken }: TokenRefreshParams) => {
    await dispatch(requestNewAccessToken(emailAddress, refreshToken, getCookie('AuthProviderAzure') === 'true' ? 'azure' : 'okta'))
  })
}
